import { CheckCircle2, AlertTriangle, MinusCircle } from "lucide-react";
import { formatAuditValue, gbp, ukDateTime } from "../lib/format";

export function checkState(c) {
  if (c.flag) return "flag";
  if (c.value === null || c.value === undefined || c.value === "") return "na";
  return "pass";
}

export function CheckIcon({ state, className = "h-4 w-4" }) {
  if (state === "flag") return <AlertTriangle className={`${className} text-primary`} />;
  if (state === "na") return <MinusCircle className={`${className} text-muted-foreground`} />;
  return <CheckCircle2 className={`${className} text-[hsl(var(--positive))]`} />;
}

const detail = (c) => {
  if (typeof c.value === "number") return gbp(c.value);
  if (c.value === true) return c.key === "no_return" ? "Yes" : "Same quarter";
  if (c.value === false) return c.key === "no_return" ? "No" : "Different quarter";
  if (c.value === null || c.value === undefined) return "Not applicable";
  return String(c.value);
};

export function ChecksList({ checks }) {
  return (
    <ul className="divide-y" data-testid="project-checks-list">
      {checks.map((c) => {
        const s = checkState(c);
        return (
          <li key={c.key} className="flex items-center gap-3 py-2.5" data-testid={`check-${c.key}`} data-state={s}>
            <CheckIcon state={s} />
            <span className="flex-1 text-sm">{c.label}</span>
            <span className="font-figure text-xs text-muted-foreground">{detail(c)}</span>
            <span className={`w-12 text-right text-[11px] font-bold uppercase ${s === "flag" ? "text-primary" : s === "pass" ? "text-[hsl(var(--positive))]" : "text-muted-foreground"}`}>{s === "flag" ? "Flag" : s === "pass" ? "Pass" : "n/a"}</span>
          </li>
        );
      })}
    </ul>
  );
}

export function HistoryList({ items }) {
  if (!items?.length) return <p className="py-6 text-sm text-muted-foreground" data-testid="history-empty">No edits yet – changes made in the app will be listed here with who, when, old and new value.</p>;
  return (
    <div className="overflow-x-auto grid-scroll">
      <table className="dt w-full text-sm" data-testid="project-history-table">
        <thead><tr className="border-b text-xs text-muted-foreground text-left">
          <th className="px-3 py-2">When</th><th className="px-3 py-2">Who</th><th className="px-3 py-2">What</th>
          <th className="px-3 py-2 text-right">Old</th><th className="px-3 py-2 text-right">New</th>
        </tr></thead>
        <tbody>
          {items.map((h) => (
            <tr key={h.id} className="border-b last:border-0" data-testid="history-row">
              <td className="px-3 py-2 whitespace-nowrap text-xs">{ukDateTime(h.at)}</td>
              <td className="px-3 py-2 whitespace-nowrap font-semibold" data-testid="history-user">{h.user_name}</td>
              <td className="px-3 py-2">{h.field}</td>
              <td className="px-3 py-2 text-right font-figure text-muted-foreground" data-testid="history-old">{formatAuditValue(h.old)}</td>
              <td className="px-3 py-2 text-right font-figure" data-testid="history-new">{formatAuditValue(h.new)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
